/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

class ImageData {
    src: string = "";
    width: number = 400;
    opacity: number = 1.0;
    positionRight: number = 0;
    positionBottom: number = 0;
    rotation: number = 0;
    horizontalFlip: boolean = false;
    behind: boolean = false;
    clip: boolean = true;
}

export default ImageData;